// extracted by mini-css-extract-plugin
module.exports =  {"secure-checkout":"u_yUEH","secureCheckout":"u_yUEH","secure-checkout-lock":"QXycij","secureCheckoutLock":"QXycij","secure-checkout-text":"I_WYyM","secureCheckoutText":"I_WYyM"};